import { Component, OnInit, signal } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PDBeLogo } from "./pdbe-logo";
import { FooterLinkConfig } from "./footerLink.model";
import { PlatformService } from "../platform.service";

@Component({
  selector: "vf-ebi-footer",
  imports: [CommonModule, PDBeLogo],
  templateUrl: "./vf-ebi-footer.component.html",
  styleUrls: ["./vf-ebi-footer.component.scss"],
})
export class VfEbiFooterComponent implements OnInit {
  protected readonly year = new Date().getFullYear();
  showBanner = false;

  constructor(private platform: PlatformService) {}

  ngOnInit(): void {
    if (this.platform.isBrowserPlatform()) {
      const agreed = this.getCookie('dataProtectionAgreed');
      this.showBanner = !agreed;
    }
  }

  closeDataProtectionBanner(): void {
    if (this.platform.isBrowserPlatform()) {
      this.setCookie('dataProtectionAgreed', 'true', 365);
      this.showBanner = false;
    }
  }

  private getCookie(name: string): string | null {
    if (this.platform.isBrowserPlatform()) {
      const platformdocument = this.platform.getDocument();
      const match = platformdocument.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? match[2] : null;
    }
  }

  private setCookie(name: string, value: string, days: number): void {
    if (this.platform.isBrowserPlatform()) {
      const platformdocument = this.platform.getDocument();
      const expires = new Date();
      expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
      platformdocument.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
    }
  }
  protected readonly footerLinks = signal<FooterLinkConfig>({
    firstColumn: {
      title: "EXPLORE PDBE",
      links: [
        { label: "Home", href: "https://www.ebi.ac.uk/pdbe/" },
        { label: "PDBe-KB", href: "https://www.ebi.ac.uk/pdbe/pdbe-kb/" },
        { label: "AlphaFold DB", href: "/" },
        { label: "Services", href: "https://www.ebi.ac.uk/pdbe/pdbe-services" },
      ],
    },
    secondColumn: {
      title: "USE AFDB",
      links: [
        { label: "Search", href: "/search/text/Homo%20sapiens" },
        { label: "Training", href: "https://www.ebi.ac.uk/training/online/courses/alphafold/" },
        { label: "FAQs", href: "/faq" },
        { label: "Downloads", href: "/download" },
      ],
    },
    thirdColumn: {
      title: "ABOUT & COMMUNITY",
      links: [
        { label: "About AlphaFold DB", href: "/about" },
        { label: "News", href: "/#news" },
        { label: "About AlphaFold", href: "https://deepmind.google/science/alphafold/" },
        { label: "Collaborations", href: "/collaborators" },
      ],
    },
  });
}
